import axios from 'axios'
// import { StorageService } from './storage-service'
export class ConfigurationServices {
  static GetIdentityUrl() {
    //return "https://localhost:44352";
    //return "http://192.168.1.14:8889";
    return "https://api.scdext.wezhan.cn";
    //return 'http://192.168.1.14:8889';
  }
  static GetDesignerUrl() {
    return this.GetSettingKey('designerUrl')
  }

  static GetJdyUrl() {
    return "http://localhost:5100";
  }
}



// WEBPACK FOOTER //
// ./src/common/configuration-services.js